import User from './User';
import SmartMatch from './SmartMatch';

export default class JobResponse {

  constructor(data = {}) {

    // 🔹 Основные поля отклика
    this.response_id = data.response_id || null;

    this.status = data.status ?? null;

    this.responceDate = data.responceDate || null;

    this.annotation = data.annotation || null;

    this.isOpenAiComplete =
      data.isOpenAiComplete || false;

    this.vacancy_id =
      data.vacancyID || null;

    this.isViewed =
      data.isViewed ?? false;


    // 🔹 AI Smart Matching
    this.smartMatch =
      new SmartMatch(
        data.smartMatch || {}
      );


    // 🔹 Кандидат
    this.worker =
      new User(
        data.worker || {}
      );
  }
}